// extracted by css-extract-rspack-plugin
export default {"toaster":"toaster-JCLgI","toast":"toast-2TzfX","close":"close-1iSZp","icon":"icon-21ybq"};